import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PostBlogs from '../components/Blog/PostBlogs';
import ManageBlogs from '../components/Blog/ManageBlogs';
import NotFound from '../components/NotFound';
import ViewBlog from '../components/Blog/ViewBlog';

const Blog = () => {
  return (
    <Routes>
      <Route path="/" element={<PostBlogs />} />
      <Route path="/manage" element={<ManageBlogs />} />
      <Route path="/view/:id" element={<ViewBlog />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Blog;
